import React, { useContext } from 'react';
import { GlobalContext } from '../../contexts/GlobalContext';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import PageTitle from '../../components/PageTitle/PageTitle';


const CookiePolicy = () => {
    const { state } = useContext(GlobalContext);
    const language = state.language || 'pt-br';
    const data = require(`../../assets/languages/${language}/cookiePolicy.json`);
    const {
        breadcrumb,
        selectedPage,
        pageTitle,
        itens,
        intro
    } = data

    return (
        <>
            <Breadcrumb
                beforeRoutes={breadcrumb}
                selectedPage={selectedPage}
                ignoreMgBot={true}
            />
            <div className='main-container'>
                <section className="section-container">
                    <PageTitle title={pageTitle} />
                    <span className='mg-bot-70' dangerouslySetInnerHTML={{ __html: intro }}></span>
                    {itens?.map((d, i) => {
                        return (
                            <>
                                <span className='text-title-secondary'>{d.label}</span>
                                <span dangerouslySetInnerHTML={{ __html: d.value }} className={`mg-bot-${i + 1 === itens.length ? '100' : '70'}`}></span>
                            </>
                        )
                    })}
                </section>
            </div>
        </>
    )
}

export default CookiePolicy